module.exports = __webpack_public_path__ + "img/bingo_ball-8.03a07f41.png";